import 'whatwg-fetch';
import '@thinkcompany/arch-ui-library';

import BrowserPopup from './browser-popup';
import ContactSearch from './contact-search';
import LocationSearch from './location-search';
import ModalContent from './modal';
import PressReleaseFilter from './press-release-filter';
import './back-to-top';
import './document-list';

new BrowserPopup();
new ContactSearch();
new LocationSearch();
new ModalContent();
new PressReleaseFilter();
